module.exports = __webpack_public_path__ + "static/img/rank_332.9b70a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_332.png
// module id = uqCi
// module chunks = 1